@if (!dataConnectionError && status === 'loaded') {
    <div class="d-flex align-items-center mb-3">
        <wdx-search-input
            class="w-100 me-3"
            (wdxChanged)="search($event)"
        ></wdx-search-input>
    </div>

    @if (colDefs) {
        <ag-grid-angular
            wdxUtilsAgGridTheme
            class="w-100"
            data-cy="accounts-table"
            [rowData]="filteredRowData"
            [columnDefs]="colDefs"
            [gridOptions]="gridOptions"
        >
        </ag-grid-angular>
    }
} @else {
    <wdx-portfolio-not-loaded
        [status]="dataConnectionError ? 'dataConnectionError' : status"
        [connectionErrorMessage]="dataConnectionError?.detail ?? ''"
        [dataTypeLabel]="dataTypeLabel"
    ></wdx-portfolio-not-loaded>
}
